import {AppActions} from '.';
import {createBrowserHistory} from 'history';
import {createStore, applyMiddleware, compose} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import {rootReducer} from './reducers';
import {routerMiddleware} from 'connected-react-router';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import thunk, {ThunkMiddleware} from 'redux-thunk';

export const history = createBrowserHistory();
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage: storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const configureStore = () => {
  const composedEnhancers = composeEnhancers(
    applyMiddleware(
      thunk as ThunkMiddleware<AppState, AppActions>,
      routerMiddleware(history),
    ),
  );
  return createStore(persistedReducer, composedEnhancers);
};

const store = configureStore();
const persistor = persistStore(store);

export {store, persistor};

export type AppState = ReturnType<typeof persistedReducer>;
